let modelData = require('./modelSchema').default;
import { isArray, isObject, isUndefined, pick } from 'helpers';

let copyKeys = [
    'contractId',
    'contractNum',
    'mtCategory',
    'title',
    'servicePhones',
    'contractInfoType',
    'contractInfoRule',
    'visitorInfoType',
    'visitorInfoRule',
    'minBuyCount',
    'maxBuyCount',
    'orderCancelTime',
    'generateTicketMethod',
    'generateTicketWorkTime',
    'needTicket',
    'getTicketRule',
    'ticketGetAddress',
    'getVoucherRule',
    'getInAddresses',
    'useDateMode',
    'useDateDays',
    'unavailableDates',
    'voucherDateEnd',
    'voucherDateBegin',
    'validWeekRule',
    'dayPriceStockRules',
    'refundType',
    'refundTimeType',
    'refundLimitDays',
    'refundLimitHours',
    'refundLimitMinutes',
    'refundFeeMode',
    'refundFee',
    'partlyRefund',
    'scheduleOnlineType',
    'scheduleOnlineTime',
    'scheduleOfflineType',
    'scheduleOfflineTime',
    'ticketCategory'
]

function removeJsonNullKey(obj) {
    let value;
    let key;
    if (isArray(obj)) {
        obj.forEach((item, index) => {
            removeJsonNullKey(item);
        });
    } else if (isObject(obj)) {
        for (key in obj) {
            if (obj.hasOwnProperty(key)) {
                value = obj[key];
                if (value === null) {
                    delete obj[key];
                }
                if (isObject(value) || isArray(value)) {
                    removeJsonNullKey(value);
                }
            }
        }
    }
}

function getDefaultModel (isDirectDeal = false, isCopy = false, data) {

    modelData.sourceType = isDirectDeal ? 5 : 1;
    modelData.generateTicketMethod = modelData.sourceType === 1 ? 1 : 3;
    if (modelData.generateTicketMethod === 3) {
        modelData.getVoucherRule.voucherLoaders = [4]
        modelData.getTicketRule.voucherLoaders = [4]
    }
    if (data) {
        removeJsonNullKey(data);
        if (isCopy) {
            data = pick(data, copyKeys)
            // 复制的时候只复制ticketCategory的poi信息，其他初始化
            const poiInfo = data.ticketCategory.poi;
            data.ticketCategory = {
                ticket: {},
                subTicket: {},
                poi: poiInfo,
                createTicketCategoryInfo: {
                    ticketCategoryName: '',
                    usePeople: 1,
                    timeLimitedRange: 3,
                    timeLimitedRangeText: '',
                    ticketCategoryPrice: '',
                    uploadMaterialType: 2,
                    uploadMaterialText: '',
                    uploadMaterialImage: []
                }
            }
        }
        if (!data.dealImageInfos) {
            data.dealImageInfos = [];
        }
        if (data.maxBuyCount === -1) {
            delete data.maxBuyCount;
        }
        // data.scheduleOfflineType = Boolean(data.scheduleOfflineTime);
        // 如果接口返回的数据值不符合初始值得要求则在此格式化;
        if (!Array.isArray(data.includeItems)) {
            data.includeItems = [{
                count: 1
            }];
        }

        if (isUndefined(data.containInsurance) || data.containInsurance === null) {
            data.containInsurance = false;
        }

        if (!Number.isInteger(data.hours)) {
            data.hours = 0;
        }

        if (!Number.isInteger(data.minutes)) {
            data.minutes = 0;
        }
        if (data.scrAttrs) {
            if (!data.scrAttrs.offlineBookRule) {
                data.scrAttrs.offlineBookRule = {
                    bookTypes: []
                };
            } else if (!data.scrAttrs.offlineBookRule.bookTypes) {
                data.scrAttrs.offlineBookRule.bookTypes = [];
            }
        }
        if (!Array.isArray(data.servicePhones) || (data.servicePhones && data.servicePhones.length === 0)) {
            data.servicePhones = [{
                phone: '',
                startHour: 0,
                startMin: 0,
                endHour: 0,
                endMin: 0
            }];
        }

        if (!data.generateTicketWorkTime) {
            data.generateTicketWorkTime = {
                startWorkHour: 8,
                startWorkMinute: 0,
                endWorkHour: 20,
                endWorkMinute: 0
            };
        }
        // 需求：若上传过特批附件则默认显示需要特批附件
        if (data.specialAuthPics && data.specialAuthPics.length) {
            data.needSpecialAuthFile = true;
        }
        modelData = Object.assign(modelData, data);
        // todo：暂时解决，其他值也有类似问题
        if (!modelData.ticketCategory.poi) {
            modelData.ticketCategory.poi = [];
        }
        if(modelData.freeTicketAssociatedAccount) {
            modelData.statementId = modelData.freeTicketAssociatedAccount;
        }
    }
    return modelData;
}

export default getDefaultModel;


// WEBPACK FOOTER //
// ./src/views/ticket/product/common/defaultModel.js